module.exports = __webpack_public_path__ + "img/compliance1.5273e4b5.svg";